function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#info-circle_svg__clip0)",
  fill: "#626262"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.5 8.438a3.937 3.937 0 100-7.875 3.937 3.937 0 000 7.875zM4.5 9a4.5 4.5 0 100-9 4.5 4.5 0 000 9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.023 3.706l-1.288.16-.046.215.253.046c.165.04.198.1.162.264l-.415 1.95c-.11.506.059.743.454.743.307 0 .663-.142.824-.336l.05-.234a.623.623 0 01-.386.138c-.155 0-.21-.109-.171-.3l.563-2.646zM4.5 3.094a.563.563 0 100-1.125.563.563 0 000 1.125z"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "info-circle_svg__clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h9v9H0z"
})));

function SvgInfoCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgInfoCircle;